import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { ExportButton } from "@/components/admin/export-button";
import { FilterButton } from "@/components/admin/filter-form";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { NumberField } from "@/components/admin/number-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { CreateButton } from "@/components/admin/create-button";
import { TopToolbar } from "../layout/TopToolbar";
import { ContractStatusBadge } from "./ContractStatusBadge";
import {
  contractPaymentTypeChoices,
  contractStatusChoices,
} from "./contractModel";
import type { Contract } from "../types";

const contractFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="status"
    choices={contractStatusChoices}
    label="resources.contracts.fields.status"
  />,
  <SelectInput
    source="payment_type"
    choices={contractPaymentTypeChoices}
    label="resources.contracts.fields.payment_type"
  />,
];

export const ContractList = () => (
  <List
    perPage={25}
    sort={{ field: "created_at", order: "DESC" }}
    filters={contractFilters}
    actions={<ContractListActions />}
    pagination={<ListPagination rowsPerPageOptions={[10, 25, 50, 100]} />}
  >
    <DataTable<Contract> rowClick="show">
      <DataTable.Col source="title" />
      <DataTable.Col source="company_id">
        <ReferenceField source="company_id" reference="companies" link="show" />
      </DataTable.Col>
      <DataTable.Col source="deal_id">
        <ReferenceField source="deal_id" reference="deals" link="show" />
      </DataTable.Col>
      <DataTable.Col
        source="status"
        render={(record) => <ContractStatusBadge status={record.status} />}
      />
      <DataTable.Col source="total_amount">
        <NumberField source="total_amount" />
      </DataTable.Col>
      <DataTable.Col source="next_payment_date" field={DateField} />
    </DataTable>
  </List>
);

const ContractListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
    <CreateButton label="resources.contracts.action.new" />
  </TopToolbar>
);
